/* eslint-disable prefer-template */
/* eslint-disable no-var */
(function (window) {
  window.URLSearchParams =
    window.URLSearchParams ||
    function (searchString) {
      var self = this;
      self.searchString = searchString;
      self.get = function (name) {
        var results = new RegExp("[?&]" + name + "=([^&#]*").exec(
          self.searchString
        );
        if (results == null) return null;
        return decodeURI(results[1]) || 0;
      };
    };
})(window);
